import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { PHONE, EMAIL } from "@/lib/constants";

const WHEN_TO_BOOK = [
  {
    title: "Homeschool testing: Available year-round",
    body: "Spring and summer (March–August) is our busiest season, and dates fill fast. Oregon families: testing must be done by August 15, so book early.",
  },
  {
    title: "Tutoring and consultations: Available year-round",
    body: null,
  },
  {
    title: "Co-op groups: Group testing at your location, arranged in advance.",
    body: "Groups of 4 or more pay $50 per student.",
  },
  {
    title: "All sessions are by appointment.",
    body: null,
  },
];

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#FFF9E6]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-2 gap-14">
        <div>
          <h2 className="text-3xl md:text-4xl text-[#1A243B] mb-8">Get in touch</h2>
          <ul className="space-y-6">
            <li className="flex items-start gap-4">
              <span className="w-11 h-11 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5 text-[#1A243B]" />
              </span>
              <p className="text-[#2D3748] text-base leading-relaxed pt-2" data-testid="contact-areas">
                Oregon: Clackamas, Clatsop, Columbia, Marion, Multnomah, Washington &amp; Yamhill counties. Washington: Clark County / Vancouver, Camas, Battle Ground. Outside these areas? We're happy to travel to you; a travel fee may apply.
              </p>
            </li>
            <li className="flex items-center gap-4">
              <span className="w-11 h-11 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0">
                <Phone className="w-5 h-5 text-[#1A243B]" />
              </span>
              <a data-testid="contact-phone-link" href={`tel:${PHONE.replace(/-/g, "")}`} className="text-[#1A243B] font-bold text-base hover:opacity-70 transition-opacity">
                Tel: {PHONE}
              </a>
            </li>
            <li className="flex items-center gap-4">
              <span className="w-11 h-11 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0">
                <Mail className="w-5 h-5 text-[#1A243B]" />
              </span>
              <a data-testid="contact-email-link" href={`mailto:${EMAIL}`} className="text-[#1A243B] font-bold text-base hover:opacity-70 transition-opacity">
                Email: {EMAIL}
              </a>
            </li>
          </ul>
          <div className="mt-10">
            <a data-testid="contact-book-btn" href="#book" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full">
              Book online
            </a>
          </div>
        </div>
        <div className="bg-white rounded-3xl p-8 md:p-10 shadow-sm h-fit">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-11 h-11 rounded-full bg-[#EBEBFA] flex items-center justify-center">
              <Clock className="w-5 h-5 text-[#1A243B]" />
            </span>
            <h3 className="text-2xl text-[#1A243B]">When to book</h3>
          </div>
          <ul className="space-y-5">
            {WHEN_TO_BOOK.map((h) => (
              <li key={h.title} data-testid="when-to-book-item" className="flex items-start gap-3 text-base leading-relaxed">
                <span className="mt-2.5 w-2 h-2 rounded-full bg-[#FFC107] shrink-0" />
                <div>
                  <p className="font-bold text-[#1A243B]">{h.title}</p>
                  {h.body && <p className="text-[#2D3748] mt-1">{h.body}</p>}
                </div>
              </li>
            ))}
          </ul>
          <a data-testid="when-to-book-btn" href="#book" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] font-bold px-8 py-3.5 rounded-full mt-8">
            Book a testing date →
          </a>
        </div>
      </div>
    </section>
  );
}
